import localforage from 'localforage';

export function createOfflineDatabase(): { offlineDatabase: LocalForage; databaseCache: LocalForage } {
    localforage.config({
        driver: localforage.INDEXEDDB,
        name: 'SaS',
        storeName: 'db',
        description: 'SaS database',
    });
    return {
        offlineDatabase: localforage.createInstance({ name: 'db' }),
        databaseCache: localforage.createInstance({ name: 'cache' }),
    };
}
